<template lang="pug">
  div
    TextBox(
      only-number,
      label="Username",
      :value.sync="model.username",
      :error-messages="errors.username",
      @update:value="clearError('username')",
    )
    Password(
      :value.sync="model.password",
      label="Password",
      :error-messages="errors.password",
      @enter="wrapProgress(submit)",
      @update:value="clearError('password')",
    )
    v-btn.mt-4(
      color="primary",
      :disabled="hasError || !valid",
      :ripple="false",
      :loading="isLoading",
      @click="wrapProgress(submit)",
    ) Access
</template>

<script>
import { formHelper } from '@/config/mixins.js';
import { mergeRight, toString, type } from 'ramda';

export default {
  props: {
    loginFn: {
      type: Function,
      rquired: true,
    },
  },

  mixins: [formHelper],

  methods: {
    submit() {
      if (this.validate()) {
        const username =
          type(this.model.username) === 'Number'
            ? toString(this.model.username)
            : this.model.username;

        this.loginFn(mergeRight(this.model, { username }));
      }
    },
  },
};
</script>
